// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"style_checkbox__WWm87","box":"style_box__2Fcpr","text":"style_text__1wBlY"};